export const getSelectedDeliveryOption = (
  allDeliveryOptions,
  selectedDeliveryKey,
) => {
  if (!allDeliveryOptions || !selectedDeliveryKey) {
    return undefined;
  }
  return allDeliveryOptions.find(
    (option) => option.key === selectedDeliveryKey,
  );
};
